// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"394":"29e8a5ff","568":"7bb13bce","786":"7fe95281","3441":"29e8a5ff","3909":"e51388ad","7811":"8e4263aa","9844":"b9dc3237"}[chunkId] + ".chunk.css";
};